import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/priceControl',
    meta: { title: '价格管理' },
    component: Layout,
    redirect: '/priceControl/list',
    children: [
      {
        path: 'list',
        meta: { title: '价格管理', activeMenu: '/priceControl' },
        component: () => import('@/views/priceControl/PriceControl.vue')
      },
      {
        path: 'detail',
        meta: { title: '价格详情', activeMenu: '/priceControl' },
        component: () => import('@/views/priceControl/PriceControlDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑价格', activeMenu: '/priceControl' },
        component: () => import('@/views/priceControl/PriceControlEdit.vue')
      }

    ]
  }

]
